/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForVmwareVcdOrganizationVdc extends models.ServiceAccountCredentialsBaseForVmwareVcd {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForVmwareVcdOrganizationVdc");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForVmwareVcdOrganizationVdc.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForVmwareVcdOrganizationVdc>): ServiceAccountCredentialsForVmwareVcdOrganizationVdc {
        let obj = Object.assign(new ServiceAccountCredentialsForVmwareVcdOrganizationVdc(), model);
        ServiceAccountCredentialsForVmwareVcdOrganizationVdc.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForVmwareVcdOrganizationVdc>): ServiceAccountCredentialsForVmwareVcdOrganizationVdc {
        if (!model) return null;
        return ServiceAccountCredentialsForVmwareVcdOrganizationVdc.newInstance(<ServiceAccountCredentialsForVmwareVcdOrganizationVdc> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForVmwareVcdOrganizationVdc) {
        if (!obj) return;

        models.ServiceAccountCredentialsForVmwareVcdOrganizationVdc.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForVmwareVcdOrganizationVdc): boolean {
        if (models.ServiceAccountCredentialsBaseForVmwareVcd.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForVmwareVcdOrganizationVdc.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
